module.exports = __webpack_public_path__ + "156d9d149940e2ba041b407de4f9f5c8.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index_jingyu_820p.mp4
// module id = 293
// module chunks = 0